import React, { memo } from 'react';

import MessageHeader from '../../../../../components/GiftMessage/MessageHeader';

export interface IMessageHeaderProps {
  recipientName?: string;
  headerText?: string;
}

const GiftMessageHeader = ({ recipientName = '', headerText = '' }: IMessageHeaderProps) => {
  const firstName = recipientName || '';
  const greetingName = firstName.trim() || 'Hi';
  const message = 'I got you something I think you’ll love!';
  const greetingText = `${greetingName}, ${message}`;

  return <MessageHeader text={headerText || greetingText} />;
};

export default memo(GiftMessageHeader);
